<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { getEditPageData } from "./EditComponentStatic";

const props = defineProps<{
  inline?: boolean;
}>();
//let backupData: string | undefined;
let isBadgeVisible = ref<boolean>(false);
let badgeColor = ref<string>("red");

var uiPage = getEditPageData();
isBadgeVisible.value = !(uiPage.uiData?.isValueChangeTrackerDisabled ?? false);
let height!: string;

function inlineStyle() {
  return height ? { height: height } : {};
}
onMounted(async () => {
  var page = getEditPageData();
  isBadgeVisible.value = !(uiPage.uiData?.isValueChangeTrackerDisabled ?? false);
});
</script>
<template>
  <div
    v-if="isBadgeVisible"
    :class="inline ? 'valueChangedBadgeInline' : 'valueChangedBadge'"
    :style="inlineStyle()"
  ></div>
</template>
<style scoped>
.valueChangedBadgeInline {
  position: relative;
}

.valueChangedBadgeInline:after {
  content: "";
  position: absolute;
  left: -8px;
  top: -1em;
  background: orange;
  text-align: center;
  border-radius: 3px;
  color: white;
  padding: 3px;
  font-size: 20px;
  width: 2px;
  height: 1em;
  overflow: hidden;
}

.valueChangedBadge {
  position: relative;
}

.valueChangedBadge::before {
  content: "";
  position: absolute;
  left: 0px;
  top: -3em;
  background: orange;
  text-align: center;
  border-radius: 3px;
  color: white;
  padding: 2px;
  font-size: 20px;
  width: 2px;
  height: 1.8em;
  overflow: hidden;
}
</style>